import { useForm } from "react-hook-form";
import Button from "./button";
import ModalBody from "./modal-body";
import ModalHeader from "./modal-header";
import Row from "./row";
interface RequestForm {
  comment: string;
}

export interface IModalContent {
  onEdit: (newTitle: string) => void;
  onCancel: () => void;
  comment: string;
  title: string;
}
function ModalContent({ onEdit, onCancel, comment, title }: IModalContent) {
  const { register, handleSubmit } = useForm<RequestForm>();
  return (
    <div className="modal-content">
      <ModalHeader title={title} />
      <ModalBody>
        <form
          className="form-row mt-45"
          autoComplete="off"
          onSubmit={handleSubmit(({ comment }) => {
            onEdit(comment);
          })}
        >
          <div className="form-group col-12 mb-3">
            <div className="d-flex align-items-center input-floating-label text-blue-m1 brc-blue-m2">
              <input
                {...register("comment")}
                placeholder="عنوان"
                type="text"
                className="form-control pr-4 shadow-none radius-1"
                defaultValue={comment}
              />
              <label
                className="floating-label text-grey-l1 text-95 ml-n3"
                htmlFor="comment"
              >
                عنوان
              </label>
            </div>
          </div>
          <Row>
            <Button
              className="btn-primary form-group btn-block col-6"
              text="اعمال"
              type="submit"
            />
            <Button
              className="btn-danger form-group btn-block col-6"
              text="لغو"
              onClick={onCancel}
            />
          </Row>
        </form>
      </ModalBody>
    </div>
  );
}
export default ModalContent;
